import { Star, ExternalLink } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./shared";
import { useSite } from "../../context/SiteContext";
import { imgUrl } from "../../lib/api";

export default function Testimonials() {
  const { content, testimonials } = useSite();
  const r = content?.ratings;
  if (!r) return null;

  return (
    <section id="depoimentos" className="py-20 lg:py-28 bg-cream" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="bg-olive rounded-3xl px-8 py-10 sm:px-12 sm:py-12 flex flex-col md:flex-row items-center justify-between gap-8 grain relative overflow-hidden" data-testid="ratings-band">
            <div className="flex items-center gap-8 flex-wrap justify-center">
              <div className="text-center">
                <p className="font-serif text-5xl sm:text-6xl text-goldlight" data-testid="ratings-score">{r.score}</p>
                <div className="flex gap-1 mt-2 justify-center text-gold" role="img" aria-label="5 estrelas">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-current" />
                  ))}
                </div>
              </div>
              <div className="h-14 w-px bg-gold/30 hidden sm:block" />
              <div>
                <p className="text-cream text-lg font-medium" data-testid="ratings-count">{r.count} opiniões</p>
                <p className="text-cream/70 text-sm mt-1" data-testid="ratings-recommended">{r.recommended} recomendado pelos casais</p>
                <p className="text-cream/50 text-xs mt-1 uppercase tracking-[0.2em]">Fonte: {r.source}</p>
              </div>
            </div>
            <a
              data-testid="ratings-view-button"
              href={r.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => window.gtag && window.gtag("event", "click_casamentoscombr")}
              className="inline-flex items-center gap-2 bg-gold hover:bg-golddark text-olivedark font-semibold text-sm tracking-wide px-7 py-3.5 rounded-full transition-all duration-300 hover:scale-[1.03]"
            >
              VER MINHAS AVALIAÇÕES NO CASAMENTOS.COM.BR <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </Reveal>

        {testimonials.length > 0 && (
          <>
            <Reveal>
              <div className="mt-20 max-w-2xl">
                <Eyebrow>Depoimentos</Eyebrow>
                <SectionTitle>Palavra de quem já viveu esse dia</SectionTitle>
              </div>
            </Reveal>
            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-7">
              {testimonials.map((t, i) => (
                <Reveal key={t.id} delay={i * 0.1}>
                  <figure className="bg-warmwhite border border-gold/20 rounded-2xl p-7 h-full hover:shadow-xl hover:shadow-gold/10 transition-shadow duration-500" data-testid={`testimonial-card-${i}`}>
                    <div className="flex gap-1 text-gold">
                      {[...Array(t.rating || 5)].map((_, j) => (
                        <Star key={j} className="w-4 h-4 fill-current" />
                      ))}
                    </div>
                    <blockquote className="mt-4 text-base font-light text-cocoa leading-relaxed italic">
                      “{t.text}”
                    </blockquote>
                    <figcaption className="mt-5 flex items-center gap-3">
                      {t.photo && (
                        <img src={imgUrl(t.photo)} alt={t.name} className="w-11 h-11 rounded-full object-cover" loading="lazy" />
                      )}
                      <div>
                        <p className="font-semibold text-ink text-sm">{t.name}</p>
                        <p className="text-xs text-stone2">{t.year}</p>
                      </div>
                    </figcaption>
                  </figure>
                </Reveal>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
}
